"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _ProgressBarLoader = _interopRequireDefault(require("./ProgressBarLoader.protypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react-hooks/exhaustive-deps */

var Container = _styledComponents.default.div.withConfig({
  displayName: "ProgressBarLoader__Container",
  componentId: "sc-1x7462n-0"
})(["position:relative;max-width:100%;height:", ";width:100%;background:", ";overflow:hidden;opacity:", ";transition:opacity 0.5s ease;"], function (props) {
  return props.theme.space.tiny;
}, function (props) {
  return props.theme.colors.darkGreen;
}, function (props) {
  return props.complete ? 0 : 1;
});
var ProgressBar = _styledComponents.default.div.withConfig({
  displayName: "ProgressBarLoader__ProgressBar",
  componentId: "sc-1x7462n-1"
})(["position:relative;height:100%;width:", ";background:", ";display:flex;align-items:center;border-radius:0px ", " ", " 0px;transition:width 1s ease;"], function (props) {
  return "".concat(props.width, "%");
}, function (props) {
  return props.theme.colors.lightGreen;
}, function (props) {
  return props.theme.space.semi;
}, function (props) {
  return props.theme.space.semi;
});
var Icon = _styledComponents.default.img.withConfig({
  displayName: "ProgressBarLoader__Icon",
  componentId: "sc-1x7462n-2"
})(["position:absolute;left:calc(100% - ", ");height:100%;"], function (props) {
  return props.theme.space.mini;
});
var Text = _styledComponents.default.div.withConfig({
  displayName: "ProgressBarLoader__Text",
  componentId: "sc-1x7462n-3"
})(["width:100%;text-align:center;margin-top:", ";font-size:", ";font-family:", ";font-weight:", ";color:", ";opacity:", ";transition:opacity 0.5s linear;"], function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.fontSize.XSmall;
}, function (props) {
  return props.theme.fontFamily.default;
}, function (props) {
  return props.theme.fontWeight.normal;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.visible ? 1 : 0;
});
var ProgressBarLoader = function ProgressBarLoader(_ref) {
  var _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    message = _ref.message,
    leadingIconPath = _ref.leadingIconPath,
    isComplete = _ref.isComplete,
    theme = _ref.theme;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    completed = _useState4[0],
    setCompleted = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    initLoad = _useState6[0],
    setInitLoad = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    currentMessage = _useState8[0],
    setCurrentMessage = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    currentLength = _useState10[0],
    setCurrentLength = _useState10[1];
  (0, _react.useEffect)(function () {
    if (initLoad) {
      setCurrentLength(25);
      setCurrentMessage(message);
      setTimeout(function () {
        setInitLoad(false);
      }, 1);
    } else if (!completed) {
      setCurrentLength(level || 25);
      if (currentMessage !== message) {
        setVisible(false);
        setTimeout(function () {
          setCurrentMessage(message);
          setVisible(true);
        }, 500);
      }
      if (level === 100 || isComplete) {
        setCurrentLength(100);
        setTimeout(function () {
          setCompleted(true);
          setVisible(false);
          setCurrentMessage('');
        }, 2000);
      }
    }
  }, [visible, message, level, completed, initLoad, isComplete]);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Container, {
    complete: completed
  }, /*#__PURE__*/_react.default.createElement(ProgressBar, {
    width: currentLength
  }, leadingIconPath && /*#__PURE__*/_react.default.createElement(Icon, {
    ref: leadingIconPath,
    src: leadingIconPath,
    alt: "Flight Icon"
  }))), /*#__PURE__*/_react.default.createElement(Text, {
    visible: visible
  }, currentMessage));
};
ProgressBarLoader.propTypes = _ProgressBarLoader.default.PropTypes;
ProgressBarLoader.defaultProps = _ProgressBarLoader.default.DefaultProps;
var _default = ProgressBarLoader;
exports.default = _default;